import { render, staticRenderFns } from "./input-tingkat-resiko.vue?vue&type=template&id=081df0eb&"
import script from "./input-tingkat-resiko.vue?vue&type=script&lang=js&"
export * from "./input-tingkat-resiko.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports